import React, { useContext } from "react";
import { MovieContext } from "../contexts/MovieContext";

export default function Navbar(props) {
  const { movies } = useContext(MovieContext);

  return (
    <div className="navbar">
      <h1>Corona Movie Festival</h1>
      <p>You have {movies.length} movies to go through</p>
    </div>
  );
}
